var exports = {
  "wV": "xdbfd91f1--a523c6--thumbs",
  "mT": "xdbfd91f1--a523c6--thumbs-wrapper",
  "C5": "xdbfd91f1--a523c6--thumbs-img",
  "XK": "xdbfd91f1--a523c6--thumbs-img-mobile",
  "oE": "xdbfd91f1--a523c6--thumbs-wrapper--mobile",
  "OS": "xdbfd91f1--a523c6--more",
  "wF": "xdbfd91f1--a523c6--more-text",
};

module.exports = exports;
